import React, { Component } from 'react';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { SettingsIcon } from '../NotificationCenter/icons/SettingsIcon';
import { TrashIcon } from '../NotificationCenter/icons/TrashIcon';
import { SuccessIcon } from '../NotificationCenter/icons/SuccessIcon';
import { trackingSettingsIconClick } from '../NotificationCenter/tracking';

interface IControlModalProps {
  disabled: boolean;
  isMobileDevice: boolean;
  markAllAsRead(): void;
  deleteNotifications(): void;
  toggleRedDotNotification(): void;
}

export class ControlModal extends Component<IControlModalProps> {
  private handleSettingsIconClick = () => {
    const { toggleRedDotNotification } = this.props;
    trackingSettingsIconClick();
    toggleRedDotNotification();
  };

  public render() {
    const { disabled, markAllAsRead, deleteNotifications } = this.props;

    return (
      <div className="c-notification-center__controls">
        <ul className="c-notification-center__controls-list">
          <li className="c-notification-center__controls-item" onClick={disabled ? undefined : markAllAsRead}>
            <span {...mergeStyles('c-notification-center__controls-item-content', disabled && 'disabled')}>
              <SuccessIcon /> Отметить как прочитанные
            </span>
          </li>
          <li className="c-notification-center__controls-item" onClick={disabled ? undefined : deleteNotifications}>
            <span {...mergeStyles('c-notification-center__controls-item-content', disabled && 'disabled')}>
              <TrashIcon /> Удалить все
            </span>
          </li>
          <li>
            <a
              className="c-notification-center__controls-item"
              onClick={this.handleSettingsIconClick}
              href="/subscriptions"
              target="_blank"
              rel="nofollow noopener"
            >
              <span className="c-notification-center__controls-item-content">
                <SettingsIcon /> Управление подписками
              </span>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
